module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "using System;\r\nusing System.Numerics;\r\nusing System.Threading.Tasks;\r\nusing Nethereum.Geth;\r\nusing Nethereum.Hex.HexTypes;\r\nusing Nethereum.Web3.Accounts.Managed;\r\n\r\n// Created with 'Nethereum-CodeGenerator' https://github.com/StefH/Nethereum-CodeGenerator by stef.heyenrath@mstack.nl (mStack B.V.)\r\nnamespace <%= locals.namespace ? namespace : 'DefaultNamespace' %>\r\n{\r\n    static class Program\r\n    {\r\n        private const string Endpoint = \"http://localhost:7545\";\r\n\r\n        // Note that the password does not matter when connecting to local Ganache\r\n        private static readonly ManagedAccount ContractOwner = new ManagedAccount(\"0x5f8206Cb73897BF21ECA2305b17DDc09FCC06eDA\", \"test\");\r\n\r\n        private static string _contractAddress;\r\n\r\n        public static void Main(string[] args)\r\n        {\r\n            TestService().Wait(15 * 60 * 1000);\r\n        }\r\n\r\n        private static async Task TestService()\r\n        {\r\n            var web3 = new Web3Geth(ContractOwner, Endpoint);\r\n\r\n            Console.WriteLine(\"Deploying Contract...\");\r\n            _contractAddress = await <%= capitalizeFirstLetter(getContractName()) %>Service.DeployContractAsync(web3, ContractOwner.Address, <%-generateConstructorInputParameters(abi)%> null, null); // If required, replace the constructor parameters.\r\n            Console.WriteLine($\"Deploying Contract done. Contract Address = {_contractAddress}\");\r\n\r\n            await TestOther();\r\n        }\r\n\r\n        private static async Task TestOther()\r\n        {\r\n            Console.WriteLine(\"TestOther\");\r\n            var web3 = new Web3Geth(ContractOwner, Endpoint);\r\n\r\n            I<%= capitalizeFirstLetter(getContractName()) %>Service service = new <%= capitalizeFirstLetter(getContractName()) %>Service(web3, _contractAddress);\r\n\r\n            // More code here...\r\n        }\r\n    }\r\n}\r\n\r\n<%_\r\nfunction getContractName() {\r\n   return locals._contractName ? locals._contractName : 'DefaultContractName';\r\n}\r\n\r\nfunction capitalizeFirstLetter(string) {\r\n    return string.charAt(0).toUpperCase() + string.slice(1);\r\n}\r\n\r\nfunction generateConstructorInputParameters(abi) {\r\n    var ret = ''\r\n    abi.forEach(function(item) {\r\n        if (item.type === 'constructor') {\r\n            ret = generateFunctionTransactionInputParameters(item);\r\n        }\r\n    });\r\n    return ret;\r\n}\r\n\r\nfunction generateFunctionTransactionInputParameters(item) {\r\n    const params = generateFunctionInputParameters(item);\r\n\r\n    return params !== '' ? params + ',' : params;\r\n}\r\n\r\nfunction generateFunctionInputParameters(item) {\r\n    var params = '';\r\n    if (item.inputs !== null) {\r\n        item.inputs.forEach( function(input, index) {\r\n            var prefix = ', ';\r\n            if (params === '') {\r\n                prefix = '';\r\n            }\r\n            params = params + prefix + 'default(' + getTypeMap(input.type) + ')'; // Add default(...)\r\n        })\r\n    } \r\n    return params;\r\n}\r\n\r\nfunction getTypeMap(typeName) {\r\n    const indexFirstBracket = typeName.indexOf('[');\r\n    if (indexFirstBracket > -1) {\r\n        var elementTypeName = typeName.substring(0, indexFirstBracket);\r\n        return getTypeMap(elementTypeName) + '[]';\r\n    }\r\n\r\n    if ('bool' === typeName) {\r\n        return typeName;\r\n    }\r\n\r\n    if (typeName.startsWith('int')) {\r\n        // default\r\n        if (typeName.length === 3) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        var length = parseInt(typeName.substring(3));\r\n        \r\n        if (length > 64) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        if (length <= 64 && length > 32) {\r\n            return 'long';\r\n        }\r\n\r\n        // ints are in 8 bits\r\n        if (length === 32 ) {\r\n            return 'int';\r\n        }\r\n\r\n        if (length === 16 ) {\r\n            return 'short';\r\n        }\r\n\r\n        if (length === 8 ) {\r\n            return 'sbyte';\r\n        }\r\n    }\r\n\r\n    if (typeName.startsWith('uint')) {\r\n       \r\n        if (typeName.length === 4) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        var length = parseInt(typeName.substring(4));\r\n        \r\n        if (length > 64) {\r\n            return 'BigInteger';\r\n        }\r\n\r\n        if (length <= 64 && length > 32) {\r\n            return 'ulong';\r\n        }\r\n        \r\n        // uints are in 8 bits steps\r\n        if (length === 32 ) {\r\n            return 'int';\r\n        }\r\n\r\n        if (length === 16 ) {\r\n            return 'short';\r\n        }\r\n\r\n        if (length === 8 ) {\r\n            return 'byte';\r\n        }\r\n    }\r\n\r\n    if (typeName === 'address') {\r\n        return 'string';\r\n    }\r\n\r\n    if (typeName === 'string') {\r\n        return 'string';\r\n    }\r\n\r\n    if (typeName === 'bytes') {\r\n        return 'byte[]';\r\n    }\r\n\r\n    // if (typeName === 'bytes32') {\r\n    //     return 'string';\r\n    // }\r\n\r\n    if (typeName.startsWith('bytes')) {\r\n        return 'byte[]';\r\n    }\r\n}\r\n_%>"
  , __filename = "src\\business\\cs-example.ejs";
try {
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("using System;\r\nusing System.Numerics;\r\nusing System.Threading.Tasks;\r\nusing Nethereum.Geth;\r\nusing Nethereum.Hex.HexTypes;\r\nusing Nethereum.Web3.Accounts.Managed;\r\n\r\n// Created with 'Nethereum-CodeGenerator' https://github.com/StefH/Nethereum-CodeGenerator by stef.heyenrath@mstack.nl (mStack B.V.)\r\nnamespace ")
    ; __line = 9
    ; __append(escapeFn( locals.namespace ? namespace : 'DefaultNamespace' ))
    ; __append("\r\n{\r\n    static class Program\r\n    {\r\n        private const string Endpoint = \"http://localhost:7545\";\r\n\r\n        // Note that the password does not matter when connecting to local Ganache\r\n        private static readonly ManagedAccount ContractOwner = new ManagedAccount(\"0x5f8206Cb73897BF21ECA2305b17DDc09FCC06eDA\", \"test\");\r\n\r\n        private static string _contractAddress;\r\n\r\n        public static void Main(string[] args)\r\n        {\r\n            TestService().Wait(15 * 60 * 1000);\r\n        }\r\n\r\n        private static async Task TestService()\r\n        {\r\n            var web3 = new Web3Geth(ContractOwner, Endpoint);\r\n\r\n            Console.WriteLine(\"Deploying Contract...\");\r\n            _contractAddress = await ")
    ; __line = 30
    ; __append(escapeFn( capitalizeFirstLetter(getContractName()) ))
    ; __append("Service.DeployContractAsync(web3, ContractOwner.Address, ")
    ; __append(generateConstructorInputParameters(abi))
    ; __append(" null, null); // If required, replace the constructor parameters.\r\n            Console.WriteLine($\"Deploying Contract done. Contract Address = {_contractAddress}\");\r\n\r\n            await TestOther();\r\n        }\r\n\r\n        private static async Task TestOther()\r\n        {\r\n            Console.WriteLine(\"TestOther\");\r\n            var web3 = new Web3Geth(ContractOwner, Endpoint);\r\n\r\n            I")
    ; __line = 41
    ; __append(escapeFn( capitalizeFirstLetter(getContractName()) ))
    ; __append("Service service = new ")
    ; __append(escapeFn( capitalizeFirstLetter(getContractName()) ))
    ; __append("Service(web3, _contractAddress);\r\n\r\n            // More code here...\r\n        }\r\n    }\r\n}\r\n\r\n")
    ; __line = 48
    ; 
function getContractName() {
   return locals._contractName ? locals._contractName : 'DefaultContractName';
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function generateConstructorInputParameters(abi) {
    var ret = ''
    abi.forEach(function(item) {
        if (item.type === 'constructor') {
            ret = generateFunctionTransactionInputParameters(item);
        }
    });
    return ret;
}

function generateFunctionTransactionInputParameters(item) {
    const params = generateFunctionInputParameters(item);

    return params !== '' ? params + ',' : params;
}

function generateFunctionInputParameters(item) {
    var params = '';
    if (item.inputs !== null) {
        item.inputs.forEach( function(input, index) {
            var prefix = ', ';
            if (params === '') {
                prefix = '';
            }
            params = params + prefix + 'default(' + getTypeMap(input.type) + ')'; // Add default(...)
        })
    } 
    return params;
}

function getTypeMap(typeName) {
    const indexFirstBracket = typeName.indexOf('[');
    if (indexFirstBracket > -1) {
        var elementTypeName = typeName.substring(0, indexFirstBracket);
        return getTypeMap(elementTypeName) + '[]';
    }

    if ('bool' === typeName) {
        return typeName;
    }

    if (typeName.startsWith('int')) {
        // default
        if (typeName.length === 3) {
            return 'BigInteger';
        }

        var length = parseInt(typeName.substring(3));
        
        if (length > 64) {
            return 'BigInteger';
        }

        if (length <= 64 && length > 32) {
            return 'long';
        }

        // ints are in 8 bits
        if (length === 32 ) {
            return 'int';
        }

        if (length === 16 ) {
            return 'short';
        }

        if (length === 8 ) {
            return 'sbyte';
        }
    }

    if (typeName.startsWith('uint')) {
       
        if (typeName.length === 4) {
            return 'BigInteger';
        }

        var length = parseInt(typeName.substring(4));
        
        if (length > 64) {
            return 'BigInteger';
        }

        if (length <= 64 && length > 32) {
            return 'ulong';
        }
        
        // uints are in 8 bits steps
        if (length === 32 ) {
            return 'int';
        }

        if (length === 16 ) {
            return 'short';
        }

        if (length === 8 ) {
            return 'byte';
        }
    }

    if (typeName === 'address') {
        return 'string';
    }

    if (typeName === 'string') {
        return 'string';
    }

    if (typeName === 'bytes') {
        return 'byte[]';
    }

    // if (typeName === 'bytes32') {
    //     return 'string';
    // }

    if (typeName.startsWith('bytes')) {
        return 'byte[]';
    }
}

    ; __line = 178
  }
  return __output.join("");
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}